import dayjs from 'dayjs';

const formatDate = (date: Date | string | undefined, formatString = 'DD/MM/YYYY'): string => {
    if (!date) {
        return '-';
    }
    return dayjs(date).format(formatString);
};

export default formatDate;
